import type { ReactNode, FC } from 'react';
import { cn } from '../../../lib/utils';

interface RepositoryPanelProps {
  header?: ReactNode;
  body: ReactNode;
  className?: string;
}

export const RepositoryPanel: FC<RepositoryPanelProps> = ({
  header,
  body,
  className,
}) => {
  return (
    // `min-h-0` lets nested flex children with `flex-1` actually
    // clip their content (otherwise their default `min-height: auto`
    // expands them to content height and the inner ScrollArea no
    // longer scrolls). See bug where Process Library showed all 24
    // entries inline with no scrollbar.
    <div className={cn('flex flex-col h-full min-h-0', className)}>
      {header}
      {body}
    </div>
  );
};
